import type { ITextContent } from "@features/Pages/SearchPage/Scripts/search.types";

export const searchForm = document.querySelector('.search-page__form') as HTMLFormElement;
export const searchInput = document.querySelector('.search-page__input') as HTMLInputElement;
export const searchFiltersSection = document.querySelector('.search-page__filters') as HTMLElement;
export const searchResultSection = document.querySelector('.search-page__result') as HTMLElement;
export const searchResultInfo = document.querySelector('.search-page__result-info') as HTMLParagraphElement;
export const searchPageLoading = document.querySelector('.search-page__loading') as HTMLElement;
export const searchPageLoadingBottom = document.querySelector('.search-page__loading-bottom') as HTMLElement;
export const initialSortOrderSelect =
  document.getElementById("sortOrder") as HTMLSelectElement | null;

export const {resultsToShow, resultsToAdd, currentLanguage, includeText, ancestors, hideFilters} = searchForm.dataset;

export const includeTextArray = includeText?.split(', ') as string[];
export const textContent: ITextContent = {
  noKeywords: includeTextArray[0],
  noResults: includeTextArray[1],
  resultFor: includeTextArray[2],
  resultsFor: includeTextArray[3],
  updated: includeTextArray[4],
  showMore: includeTextArray[5],
  show: includeTextArray[6],
  more: includeTextArray[7],
  contentType: includeTextArray[8],
  subjects: includeTextArray[9],
  showing: includeTextArray[10],
  ofTotally: includeTextArray[11],
  hide: includeTextArray[12],
  contentTypeMultiple: includeTextArray[13],
  subjectsMultiple: includeTextArray[14],
  event: includeTextArray[15],
  eventUpcoming: includeTextArray[16],
  eventPast: includeTextArray[17],
  filterTypeLabel: includeTextArray[18],
  sortAscending: includeTextArray[19],
  sortDescending: includeTextArray[20],
};

export const pageId = searchForm.dataset.pageid as string;
export const shouldRunInitialSearch = searchForm.dataset.runInitialSearch === "true";
export const isListingPage = searchResultInfo.classList.contains("listing-page__result-info");
